import React from "react";
import * as DialogPrimitive from "@/components/ui/dialog";

const { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } = DialogPrimitive as any;

export function Modal({
  open,
  onOpenChange,
  title,
  description,
  children,
  testid,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  title?: string;
  description?: string;
  children: React.ReactNode;
  testid?: string;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={testid}>
        {(title || description) && (
          <DialogHeader>
            {title && <DialogTitle>{title}</DialogTitle>}
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogHeader>
        )}
        {children}
      </DialogContent>
    </Dialog>
  );
}
